import React from 'react';
import '../Styles/AboutUs.css';
import aboutImage from '../Assets/AboutBackground.png';
import jessePhoto from '../Assets/Jesse Mam.png';
import jessePhoto2 from '../Assets/hiphop.png';
import jessePhoto3 from '../Assets/Rathinam.jpeg';
import Footer from './Footer.jsx';
const AboutUs = () => {
  return (
    <>
      <div className="about-banner">
        <img src={aboutImage} alt="About Banner" className="about-img" />
      </div>

      <section className="about-section">
        <div className="about-content">
          <h2>About GainWisdom</h2>
          <p>
            Learning with "Gain Wisdom" is a new way of broadening your knowledge and enhancing your skills 
            in a variety of ways, from engaging video lectures, audio contents, quizzes of various interesting 
            forms—fill ups, drag and drop, multiple choice questions with explanatory answers, match up with 
            instant scores. Unlimited attempts with shuffled questions and answers for practice until you 
            get it perfect! A perfect learning tool anywhere, anytime at your convenience.
          </p>
        </div>

        <section className="vision-mission-section">
          <div className="card" data-aos="zoom-in">
            <div className="icon">👁️</div>
            <h3>Our Vision</h3>
            <p>
              Vision is to provide user friendly professional course to enhance continuous career growth.
            </p>
          </div>
          <div className="card" data-aos="zoom-in" data-aos-delay="200">
            <div className="icon">🖥️</div>
            <h3>Our Mission</h3>
            <p>
              To identify and fill the gap area between Corporate requirement and the skills that learners currently possess.
            </p>
          </div>
        </section>

        <div className="management-section">
          <h2>About Our Management</h2>
          <div className="management-card">
            <div className="management-images">
            <img src={jessePhoto} alt="Jesse Francis" className="management-img" />
            <img src={jessePhoto2} alt="Jesse Francis" className="management-img" />
            <img src={jessePhoto3} alt="Jesse Francis" className="management-img" /></div>
            <div className="management-info">
              <h3 className="management-owner">Jesee Francis</h3>
              <p>
                Corporate Trainer / Digital Course Developer / HR Manager / Motivator / Public Speaker / Guest Lecturer / Professor
              </p>
              <p>
                Holds a Master’s in English and Business Administration (MA & MBA) with over two decades of experience in the corporate world.
                <br /><br />
                Possesses excellent computer & technology skills, strong relationship-building and interpersonal abilities, proven team-building and
                training expertise, top-notch management and communication skills, public speaking experience, and a collaborative, team-oriented mindset.
              </p>

              <div className="training-details">
                <h4>Delivery Modes</h4>
                <ul>
                  <li>Customized Training Programs (tailored to company needs)</li>
                  <li>Trainer-Assisted or Auto-Pilot Modules</li>
                  <li>Online / Offline / Hybrid</li>
                  <li>Location-Based: Available in India and Abroad</li>
                  <li>Infotainment Sessions: Fun-based learning</li>
                  <li>Stress Buster Activities: Games, relaxation & team-building</li>
                </ul>

                <h4>Training Categories</h4>

                <strong>Corporate Soft Skills</strong>
                <ul>
                  <li>Office Ethics</li>
                  <li>Team Building</li>
                  <li>Personality Development</li>
                  <li>Communication Skills</li>
                  <li>Email Etiquettes</li>
                  <li>Managerial Skills</li>
                  <li>People Skills</li>
                </ul>

                <strong>Healthcare Sector Training</strong>
                <ul>
                  <li>Patient Care Etiquettes</li>
                  <li>Healthcare Communication</li>
                  <li>Hospital Staff Soft Skills</li>
                  <li>Professional Conduct in Medical Environments</li>
                </ul>

                <strong>Engagement Programs</strong>
                <ul>
                  <li>Infotainment-Based Learning</li>
                  <li>Stress Buster Workshops (Games & Fun Activities)</li>
                </ul>
                <ul style={{ listStyleType: 'none', padding: 0 }}>
  <li>
    <a
      href="mailto:jesee.francis@gmail.com"
      style={{
        display: 'inline-block',
        padding: '10px',
        paddingLeft: '20px',
        paddingRight: '20px',
        color: 'white',
        backgroundColor: '#800080',
        fontWeight: 'bold',
        fontSize: '20px',
        borderRadius: '10px',
        textDecoration: 'none',
      }}
      target='_blank' rel="noreferrer"
    >
      Connect with me
    </a>
  </li>
</ul>

              </div>
            </div>
          </div>
        </div>
      </section>
       <Footer/>
    </>
  );
};

export default AboutUs;
